import React from "react";
import styles from "./NoDataMessage.module.css";

export interface NoDataMessageProps {
  message?: string;
  suggestion?: string;
}

const NoDataMessage: React.FC<NoDataMessageProps> = ({
  message = "No data available for the selected filters",
  suggestion = "Try adjusting your filters to see results",
}) => {
  return (
    <div className={styles.noDataContainer}>
      <div className={styles.noDataContent}>
        <svg
          className={styles.noDataIcon}
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
          <line x1="9" y1="9" x2="9.01" y2="9"></line>
          <line x1="15" y1="9" x2="15.01" y2="9"></line>
        </svg>
        <div className={styles.noDataTextContainer}>
          <p className={styles.noDataMessage}>{message}</p>
          <p className={styles.noDataSuggestion}>{suggestion}</p>
        </div>
      </div>
    </div>
  );
};

export default NoDataMessage;
